import { render, staticRenderFns } from "./betiem.vue?vue&type=template&id=204bd7dc"
import script from "./betiem.vue?vue&type=script&lang=js"
export * from "./betiem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports